<template>
  <div class="table-wrapper">
    <div 
      class="table-responsive"
      v-bind:class="{ 'spinner-is-visible': isSpinnerVisible }"
    >

      <table class="table">
        <thead>
          <tr>
            <SortableHeader
              style="min-width: 150px; max-width: 200px"
              :current-sort="orderBy"
              :sort-by="'PHYSICAL_ASSET_NAME'"
              @sort="reorder"
            >Asset</SortableHeader>

            <SortableHeader
              style="min-width: 150px; max-width: 200px"
              :current-sort="orderBy"
              :sort-by="'COMPONENT_NAME'"
              @sort="reorder"
            >Component</SortableHeader>

            <th>Activity</th>

            <SortableHeader
              class="text-end"
              style="width: 150px"
              :current-sort="orderBy"
              :sort-by="'DATE'"
              @sort="reorder"
            >Replacement Date</SortableHeader>
          </tr>
        </thead>

        <tbody>
          <Replacement
            v-for="(item, index) in items"
            v-bind="item"
            :key="item.id"
            :index="index"
            :policy-update="policyUpdate"
            :ref="item.id"
            :selected="isItemMarked(item.id)"
          />
        </tbody>
      </table>

      <div class="spinner"></div>

      <NoRecords 
        label="According to the search criteria, there is no related replacements"
      />

      <Pagination
        v-bind="pageInfo"
        entity-type="replacements"
        @navigate-to="paginate"
      />
      
    </div>
  </div>
</template>

<script>
import Grid from "../shared/grid/grid";
import Replacement from "./replacement"

export default {
  extends: Grid,

  components: {
    Replacement
  },

  props: {
    siteId: String
  },

  data: function () {
    return {
      items: [],

      grid: "replacements",

      defaultOrderBy: {
        field: "DATE",
        direction: "DESC"
      },

      orderBy: {
        field: "DATE",
        direction: "DESC"
      },

      pageInfo: {
        pageSize: 20,
        currentPage: 1,
        totalCount: 0,
        totalPageCount: 0
      },

      isSpinnerVisible: true
    }
  },

  computed: {
    isFilterEmpty: function() {
      return (Object.keys(this.filter).filter(x => !["siteId", "historical", "status"].includes(x))).length === 0 && this.filter.historical == false;
    },

    isFilterInHistoricalMode: function() {
      return this.filter && this.filter.historical && this.filter.historical === true;
    },

    isFilterInPrevievMode: function() {
      return this.filter.status ? ["approved", "draft", "review"].every((val) => this.filter.status.includes(val)) : false;
    },

    filterParams: function () {
      let params = {
        siteId: this.siteId
      };

      return params;
    },
  },

  methods: {
    fetch: function (params, success) {
      app.graphql.get("grid.replacements",
        params,

        (data) => {
          let replacements = data.data.replacements,
              pageInfo = replacements.pageInfo;

          success(replacements, pageInfo);
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title: "Something went wrong!",
            message: "Unable to fetch related replacements!"
          })
        }
      )
    }
  }
}
</script>
